import React from "react";
import { Field, reduxForm } from "redux-form";
import { Col } from "antd";
import { Form, Avatar, Button, Icon } from "antd";
import { required } from "./Validate";
import Title from "../common/Title";
import Description from "../common/Description";
import Hint from "../common/Hint";
import mobily from "../../img/providers/mobily.png";
import stc from "../../img/providers/stc.png";
import itc from "../../img/providers/itc.png";
import dawiyat from "../../img/providers/dawiyat.png";
import validate from "./radioValidate";
import BackArrow from "../common/leftrightbluearrow";

import { withTranslation } from "react-i18next";

const FormItem = Form.Item;
const lang = window.lang;

const renderError = ({ meta: { touched, error } }) =>
  touched && error ? <span style={{ color: "red" }}>{error}</span> : false;

const FiberProvider = (props) => {
  const {
    handleSubmit,
    previousPage,
    pristine,
    reset,
    submitting,
    invalid,
  } = props;
  const { t } = props;

  const tailFormItemLayout = {
    wrapperCol: {
      style: { float: window.lang === "en" ? "left" : "right" },
      xs: {
        span: 12,
      },
      sm: {
        span: 4,
      },
    },
  };

  const radioStyle = {
    display: "flex",
    alignItems: "center",
    height: "56px",
    // lineHeight: "56px",
  };
  return (
    <Col xs={{ span: "24" }} sm={{ span: "24" }}>
      <div id="pageID" style={{display: 'none'}}>pageProvider</div>
      <Button className="back-btn" onClick={previousPage}>
        <BackArrow />
      </Button>
      <Title title={"mobily_fiber"} />
      <Hint hint={"provider_step"} id={"Step2"} />

      <Description description={"provider_desc"} />
      <Hint hint={"provider_msg"} id="" />

      <Form onSubmit={handleSubmit}>
        <div className={"my-5"}>
          <label style={radioStyle}>
            <Field
              name="provider"
              type="radio"
              component="input"
              value="mobily"
              validate={required}
              id="mobily"
            />{" "}
            <Avatar
              shape="square"
              size={"large"}
              src={mobily}
              className="avater-icon"
            />{" "}
            {t("mobily")}
          </label>
          <label style={radioStyle}>
            <Field name="provider" type="radio" component="input" value="stc" id="stc" />{" "}
            <Avatar
              shape="square"
              src={stc}
              size={"large"}
              className="avater-icon"
            />{" "}
            {t("stc")}
          </label>
          <label style={radioStyle}>
            <Field name="provider" type="radio" component="input" value="itc" id="itc" />{" "}
            <Avatar
              shape="square"
              src={itc}
              size={"large"}
              className="avater-icon"
            />{" "}
            {t("itc")}
          </label>
          <label style={radioStyle}>
            <Field
              name="provider"
              type="radio"
              component="input"
              value="dawiyat"
              id="dawiyat"
            />{" "}
            <Avatar
              shape="square"
              src={dawiyat}
              size={"large"}
              className="avater-icon"
            />{" "}
            {t("dawiyat")}
          </label>
          <Field name="provider" component={renderError} />
        </div>
        <FormItem {...tailFormItemLayout} className={"mt-5 pt-5"}>
          <Button
            shape="round"
            block
            disabled={invalid}
            type="primary"
            htmlType="submit"
            className={lang === "en" ? "next-btn" : "next-btn-a"}
            id="provider-NextBtn"
          >
            {t("next_btn")}
            <Icon type={window.lang === "en" ? "arrow-right" : "arrow-left"} />
          </Button>
        </FormItem>
      </Form>
    </Col>
  );
};

export default withTranslation()(
  reduxForm({
    form: "wizard", //                 <------ same form name
    destroyOnUnmount: false, //        <------ preserve form data
    forceUnregisterOnUnmount: true, // <------ unregister fields on unmount
    validate,
  })(FiberProvider)
);
